(function () {
  'use strict';
  svgedit.history = svgedit.history || {};

    /**
     * @class svgedit.history.MoveElementCommand
     * @implements svgedit.history.HistoryCommand
     * History command for an element that had its DOM position changed
     * @param {Element} elem - The DOM element that was moved
     * @param {Element} oldNextSibling - The element's next sibling before it was moved
     * @param {Element} oldParent - The element's parent before it was moved
     * @param {string} [text] - An optional string visible to user related to this change
    */
  svgedit.history.MoveElementCommand = function (elem, oldNextSibling, oldParent, text) {
    this.elem = elem;
    this.text = text ? ('Move ' + elem.tagName + ' to ' + text) : ('Move ' + elem.tagName);
    this.oldNextSibling = oldNextSibling;
    this.oldParent = oldParent;
    this.newNextSibling = elem.nextSibling;
    this.newParent = elem.parentNode;
  };
  svgedit.history.MoveElementCommand.type = function () { return 'svgedit.history.MoveElementCommand'; };
  svgedit.history.MoveElementCommand.prototype.type = svgedit.history.MoveElementCommand.type;

  svgedit.history.MoveElementCommand.prototype.getText = function () {
    return this.text;
  };

    /**
     * Re-positions the element
     * @param {handleHistoryEvent: function}
    */
  svgedit.history.MoveElementCommand.prototype.apply = function (handler) {
        // TODO(codedread): Refactor this common event code into a base HistoryCommand class.
    if (handler) {
      handler.handleHistoryEvent(svgedit.history.HistoryEventTypes.BEFORE_APPLY, this);
    }

    this.elem = this.newParent.insertBefore(this.elem, this.newNextSibling);

    if (handler) {
      handler.handleHistoryEvent(svgedit.history.HistoryEventTypes.AFTER_APPLY, this);
    }
  };

    /**
     * Positions the element back to its original location
     * @param {handleHistoryEvent: function}
    */
  svgedit.history.MoveElementCommand.prototype.unapply = function (handler) {
    if (handler) {
      handler.handleHistoryEvent(svgedit.history.HistoryEventTypes.BEFORE_UNAPPLY, this);
    }

    this.elem = this.oldParent.insertBefore(this.elem, this.oldNextSibling);

    if (handler) {
      handler.handleHistoryEvent(svgedit.history.HistoryEventTypes.AFTER_UNAPPLY, this);
    }
  };

    // Function: svgedit.history.MoveElementCommand.elements
    // Returns array with element associated with this command
  svgedit.history.MoveElementCommand.prototype.elements = function () {
    return [this.elem];
  };
})();
